<style lang="scss" scoped>
.popup {
    overflow: scroll;
    -ms-overflow-style: none;
}

.back {
    height: 2.375rem;
    width: 40px;
    position: relative;
    padding-right: 16px;
    display: block;

    ::v-deep svg {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.2s;
    }

    &:hover {
        ::v-deep svg {
            transform: translateX(-6px) translateY(-50%);
        }
    }

    @media screen and (max-width: 767.98px) {
        height: 1.125rem;
    }
}

.options {
    .list-item {
        position: relative;
        padding: 24px 0 24px 40px;
        border-bottom: 1px solid #e4e4e4;
        cursor: pointer;

        .title {
            font-size: 1rem;
            font-weight: 500;
            transition: color 0.2s;
        }

        .subtitle {
            font-size: 0.875rem;
            font-weight: 300;
            line-height: 1.875rem;
            transition: color 0.2s;
        }

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            .title {
                color: var(--accent);
            }

            .subtitle {
                color: var(--accent);
            }

            .checkbox {
                border-color: var(--accent);
            }
        }
    }

    .icon {
        position: absolute;
        left: 0;
        top: 28px;
        left: 20px;
        transform: translateX(-50%);
    }

    .checkbox {
        position: absolute;
        left: 0;
        top: 48px;
        left: 20px;
        transform: translateX(-50%);
    }

    .link-item {
        &:hover {
            &:after,
            &:before {
                right: -4px;
            }

            &:before {
                opacity: 0;
            }
            &:after {
                opacity: 1;
            }
        }

        &:after,
        &:before {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            transition: opacity 0.2s, right 0.2s;
        }

        &:before {
            content: url("/svg/chevron-right-dark.svg");
            opacity: 1;
        }
        &:after {
            content: url("/svg/chevron-right-accent.svg");
            opacity: 0;
        }
    }
}

.add-activity {
    p {
        font-size: 1.25rem;
        font-weight: 300;
        line-height: 1.875rem;
    }

    .ar {
        position: relative;
    }

    img {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;

        border-radius: 4px;
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";
        -webkit-user-drag: none;
    }

    .title {
        font-size: 1rem;
        font-weight: 500;
        margin-bottom: 0;
        line-height: 1.25rem;
    }
}

.activity {
    cursor: pointer;
}

.catering {
    .list-item {
        padding: 16px 0 16px 40px;
    }
}

.clickable {
    cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <div class="popup px-16 py-24 p-md-24 p-lg-56" ref="fixBottom">
        <div class="close" @click="$emit('close')"></div>
        <transition name="fade" mode="out-in">
            <div :key="'start'" v-if="page == null || page === 'start'">
                <h2 class="mb-32">{{ translations.add_item_popup.title }}</h2>
                <p class="mb-24">{{ translations.add_item_popup.description }}</p>

                <div class="options mb-n24">
                    <div class="link-item list-item" @click="page = 'activity'">
                        <span class="icon">{{ translations.day_planning.activity.icon }}</span>
                        <p class="mb-8 title">{{ translations.day_planning.activity.label }}</p>
                        <p class="subtitle">{{ translations.day_planning.activity.description }}</p>
                    </div>
                    <div class="link-item list-item" @click="page = 'catering'">
                        <span class="icon">{{ translations.day_planning.catering.icon }}</span>
                        <p class="mb-8 title">{{ translations.day_planning.catering.label }}</p>
                        <p class="subtitle">{{ translations.day_planning.catering.description }}</p>
                    </div>
                    <div class="link-item list-item" @click="page = 'break'">
                        <span class="icon">{{ translations.day_planning.break.icon }}</span>
                        <p class="mb-8 title">{{ translations.day_planning.break.label }}</p>
                        <p class="subtitle">{{ translations.day_planning.break.description }}</p>
                    </div>
                    <div class="link-item list-item" @click="page = 'own_activity'">
                        <span class="icon">{{ translations.day_planning.own_activity.icon }}</span>
                        <p class="mb-8 title">{{ translations.day_planning.own_activity.label }}</p>
                        <p class="subtitle">{{ translations.day_planning.own_activity.description }}</p>
                    </div>
                </div>
            </div>
            <div :key="'activity'" v-else-if="page === 'activity'" class="add-activity">
                <div class="d-flex">
                    <a class="back" @click.prevent="goBack"><span v-html="svg('arrow-back')"></span></a>
                    <h2 class="mb-32">{{ translations.add_item_popup.activity.title }}</h2>
                </div>

                <p class="mb-24" v-html="translations.add_item_popup.activity.description"></p>
                <div class="row mb-16">
                    <div class="col-6" v-for="activity in items.activity" :key="activity.id">
                        <div class="activity mb-32" @click="addActivityToHoverState({type: 'activity', data: activity})">
                            <div class="ar mb-8" :style="{ 'padding-top' : `${ (arHeight / arWidth) * 100 }%` }">
                                <img :src="activity.acf.content.images[0].sizes.medium_large" :alt="activity.post_name">
                            </div>
                            <p class="title" v-html="activity.post_title ? activity.post_title : activity.title.rendered"></p>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">Activiteit</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h2 class="mb-32">{{ translations.add_item_popup.activity.extras_title }}</h2>
                <p class="mb-24" v-html="translations.add_item_popup.activity.extras_description"></p>
                <div class="row mb-n32">
                    <div class="col-6" v-for="speaker in items.speaker" :key="speaker.id">
                        <div class="activity mb-32" @click="addActivityToHoverState({type: 'speaker', data: speaker})">
                            <div class="ar mb-8" :style="{ 'padding-top' : `${ (arHeight / arWidth) * 100 }%` }">
                                <img :src="speaker.acf.image.sizes.medium_large" :alt="speaker.post_name">
                            </div>
                            <p class="title" v-html="speaker.title.rendered"></p>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">Spreker</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6" v-for="location in items.location" :key="location.id">
                        <div class="activity mb-32" @click="addActivityToHoverState({type: 'location', data: location})">
                            <div class="ar mb-8" :style="{ 'padding-top' : `${ (arHeight / arWidth) * 100 }%` }">
                                <img :src="location.acf.image.sizes.medium_large" :alt="location.post_name">
                            </div>
                            <p class="title" v-html="location.title.rendered"></p>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">Locatie</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6" v-for="staticItem in items.staticItem" :key="staticItem.id">
                        <div class="activity mb-32" @click="addActivityToHoverState({type: 'staticItem', data: staticItem})">
                            <div class="ar mb-8" :style="{ 'padding-top' : `${ (arHeight / arWidth) * 100 }%` }">
                                <img :src="staticItem.acf.image.sizes.medium_large" :alt="staticItem.post_name">
                            </div>
                            <p class="title" v-html="staticItem.post_title"></p>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">Extra</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div :key="'break'" v-else-if="page === 'break'">
                <div class="d-flex">
                    <a class="back" @click.prevent="goBack"><span v-html="svg('arrow-back')"></span></a>
                    <h2 class="mb-32">{{ translations.add_item_popup.break.title }}</h2>
                </div>
                <p class="mb-24">{{ translations.add_item_popup.break.description }}</p>
                <ValidationObserver v-slot="{ invalid }" tag="div" :slim="true" ref="observer">
                    <el-input v-model="pause.remarks" class="mb-24" type="textarea" :label="translations.add_item_popup.break.remark" rules="" />

                    <div class="d-flex align-items-center mb-24" @click="pause.needs_catering = !pause.needs_catering">
                        <el-checkbox :value="pause.needs_catering"></el-checkbox>
                        <p class="ml-12 clickable">{{ translations.add_item_popup.break.add_catering }}</p>
                    </div>

                    <template v-if="showCateringField">
                        <el-input v-model="pause.catering" class="mb-24" type="textarea" :label="translations.add_item_popup.break.catering" :placeholder="translations.add_item_popup.break.remark" rules="required" />
                    </template>

                    <div class="d-flex mt-40 justify-content-between align-items-center">
                        <button type="submit" class="btn btn-accent text-white" :disabled="invalid || success" @click.stop="addBreak">{{ translations.add_item_popup.break.save }}</button>
                        <a @click="$emit('close')">{{ translations.add_item_popup.break.cancel }}</a>
                    </div>
                </ValidationObserver>
            </div>
            <div class="catering" :key="'catering'" v-else-if="page === 'catering'">
                <div class="d-flex">
                    <a class="back" @click.prevent="goBack"><span v-html="svg('arrow-back')"></span></a>
                    <h2 class="mb-32">{{ translations.add_item_popup.catering.title }}</h2>
                </div>
                <p class="mb-24">{{ translations.add_item_popup.catering.description }}</p>
                <div class="options mb-16">
                    <div class="list-item" @click="catering.breakfast = !catering.breakfast">
                        <el-checkbox :value="catering.breakfast"></el-checkbox>
                        <p class="mb-8 title pl-16">{{ translations.add_item_popup.catering.breakfast_title }}</p>
                        <p class="subtitle pl-16">{{ translations.add_item_popup.catering.breakfast_description }}</p>
                    </div>
                    <div class="list-item" @click="catering.lunch = !catering.lunch">
                        <el-checkbox :value="catering.lunch"></el-checkbox>
                        <p class="mb-8 title pl-16">{{ translations.add_item_popup.catering.lunch_title }}</p>
                        <p class="subtitle pl-16">{{ translations.add_item_popup.catering.lunch_description }}</p>
                    </div>
                    <div class="list-item" @click="catering.snack = !catering.snack">
                        <el-checkbox :value="catering.snack"></el-checkbox>
                        <p class="mb-8 title pl-16">{{ translations.add_item_popup.catering.snack_title }}</p>
                        <p class="subtitle pl-16">{{ translations.add_item_popup.catering.snack_description }}</p>
                    </div>
                    <div class="list-item" @click="catering.dinner = !catering.dinner">
                        <el-checkbox :value="catering.dinner"></el-checkbox>
                        <p class="mb-8 title pl-16">{{ translations.add_item_popup.catering.dinner_title }}</p>
                        <p class="subtitle pl-16">{{ translations.add_item_popup.catering.dinner_description }}</p>
                    </div>
                </div>
                <a class="btn btn-accent text-white" @click="addCatering">{{ translations.add_item_popup.catering.add }}</a>
            </div>
            <div :key="'own_activity'" v-else-if="page === 'own_activity'">
                <div class="d-flex">
                    <a class="back" @click.prevent="goBack"><span v-html="svg('arrow-back')"></span></a>
                    <h2 class="mb-32">{{ translations.add_item_popup.own_activity.title }}</h2>
                </div>
                <p class="mb-24">{{ translations.add_item_popup.own_activity.description }}</p>
                <ValidationObserver v-slot="{ invalid }" tag="div" :slim="true" ref="observer">
                    <el-input v-model="own_activity.name" class="mb-24" type="text" :label="translations.add_item_popup.own_activity.name" rules="required" />
                    <el-input v-model="own_activity.remarks" class="mb-24" type="textarea" :label="translations.add_item_popup.own_activity.remark" rules="" />

                    <div class="d-flex align-items-center mb-24" @click="own_activity.has_requests = !own_activity.has_requests">
                        <el-checkbox :value="own_activity.has_requests"></el-checkbox>
                        <p class="ml-12 clickable">{{ translations.add_item_popup.own_activity.need_help }}</p>
                    </div>

                    <template v-if="showRequestField">
                        <el-input v-model="own_activity.requests" class="mb-24" type="textarea" :label="translations.add_item_popup.own_activity.need_help_title" :placeholder="translations.add_item_popup.own_activity.need_help_field" rules="required" />
                    </template>

                    <div class="d-flex mt-40 justify-content-between align-items-center">
                        <button type="submit" class="btn btn-accent text-white" :disabled="invalid || success" @click.stop="addOwnActivity">{{ translations.add_item_popup.own_activity.save }}</button>
                        <a @click="$emit('close')">{{ translations.add_item_popup.own_activity.cancel }}</a>
                    </div>
                </ValidationObserver>
            </div>
        </transition>
    </div>
</template>

<script>
import core from "../day-configurator-core";
import safariFixedBottom from "../../mixins/safari-fixed-bottom";
import { bus } from '@/app';
import hasForm from '../../mixins/has-form'
import { ValidationObserver, ValidationProvider, validate } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import nl from 'vee-validate/dist/locale/nl.json';
for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: nl.messages[rule]
    });
}

export default {
    mixins: [core, safariFixedBottom, hasForm],

    components: { ValidationObserver, ValidationProvider },

    data: () => ({
        page: null,
        ratio: '284:200',

        catering: {
            breakfast: false,
            lunch: false,
            snack: false,
            dinner: false,
        },

        own_activity: {
            name: '',
            remarks: '',
            has_requests: false,
            requests: ''
        },

        pause: {
            remarks: '',
            needs_catering: false,
            catering: ''
        }
    }),

    props: {
        openPage: {
            required: false,
        },
        items: {
            required: true,
        },
        start: {
            required: false,
        },
    },

    created() {
        if (this.openPage) this.page = this.openPage;
    },

    mounted() {
        this.initCateringOptions();
    },

    methods: {
        addOwnActivity() {
            let ownActivity = {
                name: this.own_activity.name,
                has_requests: this.own_activity.has_requests,
                requests: this.own_activity.requests,
                remarks: this.own_activity.remarks
            }
            this.addActivityToHoverState({ type: 'own_activity', data: ownActivity })
        },

        addBreak() {
            let pause = {
                remarks: this.pause.remarks,
                needs_catering: this.pause.needs_catering,
                catering: this.pause.catering
            }
            this.addActivityToHoverState({ type: 'break', data: pause })
        },

        goBack() {
            this.page = 'start';
        },

        addCatering() {
            let addCateringItems = [];
            let removeCateringItems = [];

            let existingBreakfastIndex = -1;
            let existingLunchIndex = -1;
            let existingSnackIndex = -1;
            let existingDinnerIndex = -1;

            let activities = this.schedule.activities;
            for (let i = 0; i < activities.length; i++) {
                if (activities[i].type === 'catering') {
                    switch (activities[i].data.type) {
                        case "breakfast":
                            existingBreakfastIndex = i;
                            break;
                        case "lunch":
                            existingLunchIndex = i;
                            break;
                        case "snack":
                            existingSnackIndex = i;
                            break;
                        case "dinner":
                            existingDinnerIndex = i;
                            break;
                    }
                }
            }
            if (this.catering.breakfast && existingBreakfastIndex < 0) {
                let breakfast = {
                    type: 'catering',
                    start: '08:00',
                    duration: 60,
                    data: {
                        type: 'breakfast'
                    }
                }

                addCateringItems.push(breakfast);
            }
            if (!this.catering.breakfast && existingBreakfastIndex >= 0) {
                removeCateringItems.push(existingBreakfastIndex);
            }

            if (this.catering.lunch && existingLunchIndex < 0) {
                let lunch = {
                    type: 'catering',
                    start: '12:00',
                    duration: 60,
                    data: {
                        type: 'lunch'
                    }
                }

                addCateringItems.push(lunch);
            }
            if (!this.catering.lunch && existingLunchIndex >= 0) {
                removeCateringItems.push(existingLunchIndex);
            }

            if (this.catering.snack && existingSnackIndex < 0) {
                let snack = {
                    type: 'catering',
                    start: '16:00',
                    duration: 30,
                    data: {
                        type: 'snack'
                    }
                }

                addCateringItems.push(snack);
            }
            if (!this.catering.snack && existingSnackIndex >= 0) {
                removeCateringItems.push(existingSnackIndex);
            }

            if (this.catering.dinner && existingDinnerIndex < 0) {
                let dinner = {
                    type: 'catering',
                    start: '18:00',
                    duration: 60,
                    data: {
                        type: 'dinner'
                    }
                }

                addCateringItems.push(dinner);
            }
            if (!this.catering.dinner && existingDinnerIndex >= 0) {
                removeCateringItems.push(existingDinnerIndex);
            }

            bus.$emit('planningUpdate', { add: addCateringItems, remove: removeCateringItems.sort((a, b => a - b)) });
            this.$emit('close');
        },

        initCateringOptions() {
            let cateringOptions = this.schedule.activities.filter(a => a.type === 'catering');
            for (let i = 0; i < cateringOptions.length; i++) {
                switch (cateringOptions[i].data.type) {
                    case "breakfast":
                        this.catering.breakfast = true;
                        break;
                    case "lunch":
                        this.catering.lunch = true;
                        break;
                    case "snack":
                        this.catering.snack = true;
                        break;
                    case "dinner":
                        this.catering.dinner = true;
                        break;
                }
            }
        },

        addActivityToHoverState(activity_object) {
            if (this.start) {
                let newActivity = this.makeActivityObject(activity_object.type, this.start, 60, activity_object);
                if (newActivity.type === 'listed') {
                    this.$store.dispatch('dayConfigurator/addExternalActivity', activity_object.data).then(() => {
                        bus.$emit('planningUpdate', { add: [newActivity] });
                    });
                } else {
                    bus.$emit('planningUpdate', { add: [newActivity] });
                }
            } else {
                bus.$emit('hoverStateUpdate', activity_object);
            }
            this.$emit('close');
        }
    },

    computed: {
        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },

        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },

        showRequestField() {
            return this.own_activity.has_requests;
        },

        showCateringField() {
            return this.pause.needs_catering;
        },
    }
}
</script>